import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Alert, AlertDescription } from './ui/alert';
import { Calendar, CheckCircle2, XCircle, Download } from 'lucide-react';
import { STATUS_COLORS } from './declarationDommageShared';

export const DeclarationDetailsModal = ({ declaration, onClose, downloadPDF }) => {
  if (!declaration) return null;
  return (
        <div 
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          onClick={() => onClose()}
        >
          <Card 
            className="max-w-2xl w-full max-h-[80vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle className="text-[#002d5b]">
                  {declaration.reference}
                </CardTitle>
                <Badge className={`${STATUS_COLORS[declaration.status]} text-white`}>
                  {declaration.status_label}
                </Badge>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <strong>Type de dommage :</strong>
                  <p>{declaration.dommage?.type_dommage_label}</p>
                </div>
                <div>
                  <strong>Date découverte :</strong>
                  <p>{declaration.dommage?.date_decouverte}</p>
                </div>
              </div>
              
              <div>
                <strong>Description :</strong>
                <p className="bg-gray-50 p-3 rounded mt-1 text-sm">
                  {declaration.dommage?.description}
                </p>
              </div>
              
              {declaration.expertise?.planifiee && (
                <Alert className="bg-yellow-50 border-yellow-200">
                  <Calendar className="h-4 w-4" />
                  <AlertDescription>
                    <strong>Expertise planifiée le :</strong>{' '}
                    {declaration.expertise.date_expertise}
                    <br />
                    <strong>Expert :</strong> {declaration.expertise.expert_nom}
                  </AlertDescription>
                </Alert>
              )}
              
              {declaration.decision_comite?.decision && (
                <Alert className={
                  declaration.decision_comite.decision === 'ACCEPTE' 
                    ? 'bg-green-50 border-green-200' 
                    : 'bg-red-50 border-red-200'
                }>
                  {declaration.decision_comite.decision === 'ACCEPTE' ? (
                    <CheckCircle2 className="h-4 w-4 text-green-600" />
                  ) : (
                    <XCircle className="h-4 w-4 text-red-600" />
                  )}
                  <AlertDescription>
                    <strong>Décision :</strong> {declaration.decision_comite.decision}
                    {declaration.decision_comite.montant_accorde && (
                      <>
                        <br />
                        <strong>Montant accordé :</strong>{' '}
                        {declaration.decision_comite.montant_accorde.toLocaleString('fr-FR')} €
                      </>
                    )}
                    <br />
                    <strong>Commentaire :</strong> {declaration.decision_comite.commentaire}
                  </AlertDescription>
                </Alert>
              )}
              
              <div className="pt-4 border-t flex justify-end gap-2">
                <Button variant="outline" onClick={() => onClose()}>
                  Fermer
                </Button>
                <Button onClick={() => downloadPDF(declaration.reference)}>
                  <Download className="h-4 w-4 mr-2" />
                  Télécharger PDF
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
  );
};
